import React from "react"
import { useHistory } from "react-router"

import { NotificationBox } from "./styles"
import { NOTIFICATION_MESSAGE } from "./"

import { useStartQuiz } from "graphql/mutations/startQuiz"
import { useAssertRootQueryLoaded } from "graphql/smart-queries/user"
import { maybeGetActiveJourney } from "shared/user/helpers"
import { baseRoutes } from "routes"
import { NextActionEnum } from "typings/types"
import { TEST_MARKER_CONSTANTS } from "shared/test-selectors"

export const AnnualRenewalNotification: React.FC = () => {
  const { user } = useAssertRootQueryLoaded()
  const activeJourney = maybeGetActiveJourney(user)
  const kind = activeJourney ? activeJourney.kind : undefined

  const [startQuiz] = useStartQuiz()
  const history = useHistory()

  const onClick = async () => {
    /* quiz has already been started for this user */
    if (!activeJourney?.nextActions.includes(NextActionEnum.StartQuiz)) {
      history.push(baseRoutes.renewalConsult())
    }
    if (!kind) {
      return
    }

    /* start renewal quiz */
    const result = await startQuiz({
      variables: { params: { journeyKind: kind } }
    })

    if (result.error) {
      return result.error
    }
    history.push(baseRoutes.renewalConsult())
    return
  }

  return (
    <NotificationBox
      description={NOTIFICATION_MESSAGE.shouldCompleteAnnualRenewal}
      onClick={onClick}
      dataTest={TEST_MARKER_CONSTANTS.ANNUAL_RENEWAL_NOTIFICATION}
    >
      Complete your annual renewal
    </NotificationBox>
  )
}
